"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectoryViewWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    DirectoryViewText: {
        display: "flex",
        alignItems: "center",
        height: 20,
        fontSize: 16,
        fontWeight: 500,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 6,
        paddingBottom: 6,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    DirectoryViewTextRedColor: {
        display: "flex",
        alignItems: "center",
        height: 20,
        fontSize: 16,
        fontWeight: 500,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 6,
        paddingBottom: 6,
        color: "rgb(245,63,73)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "&:hover": {
            backgroundColor: theme !== undefined
                ? theme.app.DirectoryViewWrap.backgroundColor
                : "",
            borderRadius: 3,
            cursor: "pointer",
        },
        "&:active": {
            color: "rgb(255,255,255)",
            backgroundColor: "rgb(238,73,76)",
        },
    },
    DirectoryViewTextBlueColor: {
        display: "flex",
        alignItems: "center",
        height: 20,
        fontSize: 16,
        fontWeight: 500,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 6,
        paddingBottom: 6,
        color: "rgb(107,138,214)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "&:hover": {
            backgroundColor: theme !== undefined
                ? theme.app.DirectoryViewTextBlueColor.backgroundColor
                : "",
            borderRadius: 3,
            cursor: "pointer",
        },
        "&:active": {
            color: "rgb(255,255,255)",
            backgroundColor: "rgb(107,138,214)",
        },
    },
}); });
function DirectoryViewWrap(props) {
    var children = props.children, color = props.color;
    var classes = useStyles();
    return (React.createElement("div", null,
        color === undefined && (React.createElement("div", { className: classes.DirectoryViewText }, children)),
        color != undefined &&
            (color === "red" ? (React.createElement("div", { className: classes.DirectoryViewTextRedColor }, children)) : (React.createElement("div", { className: classes.DirectoryViewTextBlueColor }, children)))));
}
exports.DirectoryViewWrap = DirectoryViewWrap;
//# sourceMappingURL=DirectoryViewWrap.js.map